import { render, staticRenderFns } from "./CharityDialog.vue?vue&type=template&id=b411389c&scoped=true"
import script from "./CharityDialog.vue?vue&type=script&lang=js"
export * from "./CharityDialog.vue?vue&type=script&lang=js"
import style0 from "./CharityDialog.vue?vue&type=style&index=0&id=b411389c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b411389c",
  null
  
)

export default component.exports